module.exports = __webpack_public_path__ + "static/media/nato_strap_khaki.a1a5f8d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nato_strap_khaki.png
// module id = 111
// module chunks = 0